'use client';

import * as React from 'react';
import { ActiveLink } from '@/components/ui/ActiveLink/ActiveLink';
import useScrollBox from '@/components/hooks/useScrollBox';
import { IMenu } from '@/lib/types';

const Menu: React.FunctionComponent<{
  menu: IMenu;
}> = (props) => {
  const { menu } = props;
  const scrollWrapperRef = React.useRef<HTMLDivElement | null>(null);

  useScrollBox(scrollWrapperRef);

  return (
    <div className={'header__menu'}>
      <div
        className={'header__menu__scroller'}
        ref={scrollWrapperRef}
      >
        <ul className={'header__menu__items'}>
          {menu.links.map((item, linkIndex) => {
            const props = item.url.startsWith('/')
              ? {}
              : {
                  target: '_self',
                  rel: 'noopener noreferrer',
                };
            return (
              <li key={linkIndex}>
                <ActiveLink
                  href={item.url}
                  {...props}
                >
                  {item.label}
                </ActiveLink>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

Menu.displayName = 'Menu';

export default Menu;
